import { apiClient } from './client';

export interface SettlementRun {
  id: string;
  run_key: string;
  week_ending_at: string;
  status: 'scheduled' | 'running' | 'succeeded' | 'failed';
  scheduled_at: string;
  started_at: string | null;
  completed_at: string | null;
  duration_seconds: number | null;
  result: {
    users_processed?: number;
    total_profit_cents?: number;
    total_distributed_cents?: number;
    snapshots_created?: number;
  };
  error: {
    message: string;
    backtrace: string[];
  } | null;
  trigger_source: string;
}

export interface SettlementSummary {
  total_runs: number;
  succeeded: number;
  failed: number;
  running: number;
  scheduled: number;
  last_run: string | null;
  last_success: string | null;
}

export interface SettlementOverviewResponse {
  runs: SettlementRun[];
  summary: SettlementSummary;
}

const settlementEndpoints = {
  getOverview: async (): Promise<SettlementOverviewResponse> => {
    return await apiClient.get('/api/admin/settlements/overview');
  },
};

export default settlementEndpoints;
